export default {
  INAUDIBLE: 'inaudible', // ไม่ได้ยิน
  EARWAX: 'earwax', // ขี้หู
  SMELL: 'smell', // มีกลิิ่น
  OTITIS: 'otitis', // หูอักเสบ
  MITE: 'mite' // ไร
}
